import { useEffect, useRef, useState } from "react";
import { Button, Col, Container, ListGroup, Modal, Row } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Bar } from 'react-chartjs-2'; 
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import BarChart from '../components/BarChart';
import "../styles/Results.css";
import Papa from 'papaparse';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import html2canvas from 'html2canvas';
import InfoIcon from '../components/InfoIcon';
import PositiveAndNegativeBarChart from "../components/WaterfallChart";

// Registrar componentes necesarios de Chart.js
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

function ResultPage() {
    const [t, i18n] = useTranslation("global");
    const { state } = useLocation();
    const { panssResults } = state;
    const [show, setShow] = useState(false);
    const contentRef = useRef<HTMLDivElement>(null);
    const [lowestIndicators, setLowestIndicators] = useState([]);
    const [loading, setLoading] = useState(false);
    type ChartId =
        | "panssp"
        | "del_artificial"
        | "psy_haltotal"
        | "psy_deltotal"
        | "Rosen_total"
        | "BCIS_reflex"
        | "BCIS_certez"
        | "completation";
    const chartRefs = useRef<{ [key in ChartId]?: HTMLDivElement | null }>({});
    const [visibleChart, setVisibleChart] = useState<ChartId | null>(null);
    



    const improvementText = t("results.titles.improvement");
    const deteriorationText = t("results.titles.deterioration");

    const keyMapping = {
        diference_perc_P: { name: 'Panss Positive', og_name: "diference_perc_P", url: 'https://example.com/panss-positive', value: panssResults.diference_perc_P},
        diference_PSY_DEL: { name: 'PSYRAT Del', og_name: "diference_PSY_DEL", url: 'https://example.com/psyrat-del', value: panssResults.diference_PSY_DEL},
        diference_ROSENTOTAL: { name: 'Rosen', og_name: "diference_ROSENTOTAL", url: 'https://example.com/rosen', value: panssResults.diference_ROSENTOTAL},
        diference_BCISREFLEX: { name: 'BCIS Reflex', og_name: "diference_BCISREFLEX", url: 'https://example.com/bcis', value: panssResults.diference_BCISREFLEX},
        diference_BCISCERTEZ: { name: 'BCIS Certez', og_name: "diference_BCISCERTEZ", url: 'https://example.com/bcis', value: panssResults.diference_BCISCERTEZ},
    };
     
    /*const waterfallDataList = [
        { 
            title: "Panss Positive", 
            data: panssResults.prediction_P_explain_vals.flat().map((value, index) => ({ 
                name: panssResults.pred_feature_names[index] || "Unknown", 
                value: isNaN(Number(value)) ? 0 : Number(value)  // 🔥 Asegurar que los valores sean números
            })) 
        },
        { 
            title: "Delusions Artificial", 
            data: panssResults.prediction_del_artificial_explain_vals.flat().map((value, index) => ({ 
                name: panssResults.pred_feature_names[index] || "Unknown", 
                value: isNaN(Number(value)) ? 0 : Number(value)
            })) 
        },
        { 
            title: "PSY HAL", 
            data: panssResults.prediction_psy_hal_explain_vals.flat().map((value, index) => ({ 
                name: panssResults.pred_feature_names[index] || "Unknown", 
                value: isNaN(Number(value)) ? 0 : Number(value)
            })) 
        },
        { 
            title: "PSY DEL", 
            data: panssResults.prediction_psy_del_explain_vals.flat().map((value, index) => ({ 
                name: panssResults.pred_feature_names[index] || "Unknown", 
                value: isNaN(Number(value)) ? 0 : Number(value)
            })) 
        },
        { 
            title: "Rosen Total", 
            data: panssResults.prediction_rosentotal_explain_vals.flat().map((value, index) => ({ 
                name: panssResults.pred_feature_names[index] || "Unknown", 
                value: isNaN(Number(value)) ? 0 : Number(value)
            })) 
        },
        { 
            title: "BCIS Reflex", 
            data: panssResults.prediction_bcisreflex_explain_vals.flat().map((value, index) => ({ 
                name: panssResults.pred_feature_names[index] || "Unknown", 
                value: isNaN(Number(value)) ? 0 : Number(value)
            })) 
        },
        { 
            title: "BCIS Certez", 
            data: panssResults.prediction_bciscertez_explain_vals.flat().map((value, index) => ({ 
                name: panssResults.pred_feature_names[index] || "Unknown", 
                value: isNaN(Number(value)) ? 0 : Number(value)
            })) 
        },
        { 
            title: "MCT Completion", 
            data: panssResults.completion_explain_vals.flat().map((value, index) => ({ 
                name: panssResults.pred_feature_names[index] || "Unknown", 
                value: isNaN(Number(value)) ? 0 : Number(value)
            })) 
        }
    ];*/
    


    function checkNumberSign(number) {
        if (number > 0) {
          return '#387d38';
        } else if (number < 0) {
          return '#c65353';
        } else {
          return '#FFFFFF';
        }
      }
      
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    useEffect(() => {
        console.log("panssResults:", panssResults);
        
        if (panssResults) {
            const differenceKeys = ["diference_perc_P", "diference_PSY_DEL", "diference_ROSENTOTAL", "diference_BCISREFLEX", "diference_BCISCERTEZ"];
    
            // Ordenar indicadores basados en los valores
            const sortedIndicators = differenceKeys.sort((a, b) => keyMapping[a]["value"] - keyMapping[b]["value"]);
    
            
            // Separar indicadores BCIS y no BCIS
            const bcisIndicators = sortedIndicators.slice(0,3).filter(key => key.startsWith("diference_BCIS"));
            
            let printIndicators = [];
            
            // Verifica cuántos indicadores BCIS hay y selecciona los indicadores adecuados
            if (bcisIndicators.length >= 2) {
                // Si hay 2 o más indicadores BCIS, selecciona los primeros 4 indicadores ordenados
                printIndicators = sortedIndicators.slice(0, 4);
            } else {
                // Si hay menos de 2 indicadores BCIS, selecciona los primeros 3 indicadores no BCIS
                printIndicators = sortedIndicators.slice(0, 3);
            }
    
            // Actualiza el estado con los indicadores seleccionados
            setLowestIndicators(printIndicators);
            
        }
    }, [panssResults]);

    const handleDownloadCSV = () => {
        const warningText = [t('results.warningAIDoc')];

        const data_old = [['Age','Gender','Education','Marital','Living','Employment','Alcohol','Caffeine','Illicite','Cannabis','Tabacoo','Diagnosis','Panss Positive 1',
                       'Panss Positive 2','Panss Positive 3','Panss Positive 4','Panss Positive 5','Panss Positive 6','Panss Positive 7','Panss Global 9','Panss Positive','Panss Negative',
                       'Panss General','Panss Total','TMT A','TMT B','GAF','Quality of Life (QoL)','JTC','Depression','Panss Positive','Delusion according to PANSS',
                       'PSYRAT Hal','PSYRAT Del','Rosen','BCIS Total','BCIS Reflex','BCIS Certez','Pred Panss Positive','Pred Delusion according to PANSS','Pred PSYRAT Hal',
                       'Pred PSYRAT Del','Pred Rosen','Pred BCIS Total','Pred BCIS Reflex','Pred BCIS Certez','Percentage Difference Panss Positive',
                       'Percentage Difference Delusion according to PANSS','Percentage Difference PSYRAT Hal','Percentage Difference PSYRAT Del','Percentage Difference Rosen',
                       'Percentage Difference BCIS Total','Percentatge Difference BCIS Reflex','Percentage Difference BCIS Certez'],
                      [panssResults.pre_Age,panssResults.pre_Gender,panssResults.pre_Education,panssResults.pre_Marital,panssResults.pre_Living,panssResults.pre_Employment,
                       panssResults.pre_Alcohol,panssResults.pre_Caffeine,panssResults.pre_Illicite,panssResults.pre_Cannabis,panssResults.pre_Tabacoo,panssResults.pre_Diagnosis,
                       panssResults.pre_panssp1,panssResults.pre_panssp2,panssResults.pre_panssp3,panssResults.pre_panssp4,panssResults.pre_panssp5,panssResults.pre_panssp6,
                       panssResults.pre_panssp7,panssResults.pre_panssg9,panssResults.pre_panss_P,panssResults.pre_panss_N,panssResults.pre_panss_G,panssResults.pre_panss_T,panssResults.pre_TMT_A_pd,
                       panssResults.pre_TMT_B_pd,panssResults.pre_gaf,panssResults.pre_gen_qol,panssResults.pre_jtc,panssResults.pre_Depression,panssResults.pre_panss_P,
                       panssResults.pre_del_artifical,panssResults.pre_psy_haltotal,panssResults.pre_psy_deltotal,panssResults.pre_Rosen_total,panssResults.pre_BCISTOTAL,
                       panssResults.pre_BCIS_reflex,panssResults.pre_BCIS_certez,panssResults.prediction_P,panssResults.prediction_del_artificial,panssResults.prediction_psy_hal,
                       panssResults.prediction_psy_del,panssResults.prediction_rosentotal,panssResults.prediction_bcis_total,panssResults.prediction_bcisreflex,
                       panssResults.prediction_bciscertez,` ${panssResults.diference_perc_P}`,` ${panssResults.diference_DEL_ARTIFICIAL}`,` ${panssResults.diference_PSY_HAL}`,
                       ` ${panssResults.diference_PSY_DEL}`,` ${panssResults.diference_ROSENTOTAL}`,` ${panssResults.diference_BCISTOTAL}`,` ${panssResults.diference_BCISREFLEX}`,` ${panssResults.diference_BCISCERTEZ}`]
                     ];

        const data = [
                    [warningText],
                    ['Age','Gender','Education','Marital','Living','Employment','Alcohol','Caffeine','Illicite','Cannabis','Tabacoo','Diagnosis','pre_panss_P','pre_panss_N',
                    'pre_panss_G','pre_panss_T','pre_panssp1','pre_panssp2','pre_panssp3','pre_panssp4','pre_panssp5','pre_panssp6','pre_panssp7','pre_panssg9','pre_BCIS_reflex',
                    'pre_BCIS_certez','pre_Rosen_total','pre_TMT_A_pd','pre_TMT_B_pd','pre_gaf','pre_psy_haltotal','pre_psy_deltotal','pre_gen_qol','pre_jtc','pre_Depression',
                    'post_panss_P','post_BCIS_reflex','post_BCIS_certez','post_Rosen_total','post_psy_haltotal','post_psy_deltotal','Delusions_PANSS','MCT_Completation','Prob_MCT_Completation',
                    'Percentage_Difference_Panss_P','Percentatge_Difference_BCIS_Reflex','Percentage_Difference_BCIS_Certez','Percentage_Difference_Rosen','Percentage_Difference_PSYRAT_Hal',
                    'Percentage_Difference_PSYRAT_Del','Percentage_Difference_Delusion_PANSS'],
                    [panssResults.pre_Age,panssResults.pre_Gender,panssResults.pre_Education,panssResults.pre_Marital,panssResults.pre_Living,panssResults.pre_Employment,panssResults.pre_Alcohol,
                    panssResults.pre_Caffeine,panssResults.pre_Illicite,panssResults.pre_Cannabis,panssResults.pre_Tabacoo,panssResults.pre_Diagnosis,panssResults.pre_panss_P,panssResults.pre_panss_N,
                    panssResults.pre_panss_G,panssResults.pre_panss_T,panssResults.pre_panssp1,panssResults.pre_panssp2,panssResults.pre_panssp3,panssResults.pre_panssp4,panssResults.pre_panssp5,
                    panssResults.pre_panssp6,panssResults.pre_panssp7,panssResults.pre_panssg9,panssResults.pre_BCIS_reflex,panssResults.pre_BCIS_certez,panssResults.pre_Rosen_total,panssResults.pre_TMT_A_pd,
                    panssResults.pre_TMT_B_pd,panssResults.pre_gaf,panssResults.pre_psy_haltotal,panssResults.pre_psy_deltotal,panssResults.pre_gen_qol,panssResults.pre_jtc,panssResults.pre_Depression,
                    panssResults.prediction_P,panssResults.prediction_bcisreflex,panssResults.prediction_bciscertez,panssResults.prediction_rosentotal,
                    panssResults.prediction_psy_hal,panssResults.prediction_psy_del,panssResults.prediction_del_artificial,panssResults.completation,`${panssResults.completion_prob}`,
                    `${panssResults.diference_perc_P}`,`${panssResults.diference_BCISREFLEX}`,`${panssResults.diference_BCISCERTEZ}`,`${panssResults.diference_ROSENTOTAL}`,`${panssResults.diference_DEL_ARTIFICIAL}`,
                    `${panssResults.diference_PSY_DEL}`,`${panssResults.diference_PSY_HAL}`]
        ];

        
        const csv = Papa.unparse(data);
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', 'results.csv');
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleDownloadPDF = async () => {
        setLoading(true);
        document.body.style.overflow = 'hidden';
    
        try {
            const doc = new jsPDF();
            const warningText = t('results.warningAIDoc');
    
            // Texto inicial
            doc.setFontSize(12);
            const marginLeft = 10;
            const marginTop = 10;
            const pageWidth = doc.internal.pageSize.getWidth() - 2 * marginLeft;
            const textLines = doc.splitTextToSize(warningText, pageWidth);
            doc.text(textLines, marginLeft, marginTop, { maxWidth: pageWidth });
    
            const chartY = marginTop + textLines.length * 7 + 10;
    
            const chart1 = document.querySelector('.chart-container .canvas-wrapper');
            const chart2 = document.querySelector('.chart-container-right .canvas-wrapper');
            
            // Forzar tamaño visual consistente para los gráficos principales
            if (chart1 && chart2) {
                chart1.style.display = 'block';
                chart1.style.width = '900px';
                chart1.style.height = '600px';

                chart2.style.display = 'block';
                chart2.style.width = '600px';
                chart2.style.height = '600px';

                await new Promise(res => setTimeout(res, 500)); // Espera para que se apliquen los estilos

                const canvas1 = await html2canvas(chart1, {
                    scale: 2,
                    useCORS: true,
                    backgroundColor: "#fff"
                });

                const canvas2 = await html2canvas(chart2, {
                    scale: 2,
                    useCORS: true,
                    backgroundColor: "#fff"
                });

                const imgData1 = canvas1.toDataURL('image/png');
                const imgData2 = canvas2.toDataURL('image/png');

                const imgWidth1 = pageWidth * 0.65;
                const imgWidth2 = pageWidth * 0.3;

                const maxHeight = Math.max(
                    (canvas1.height * imgWidth1) / canvas1.width,
                    (canvas2.height * imgWidth2) / canvas2.width
                );

                doc.addImage(imgData1, 'PNG', marginLeft, chartY, imgWidth1, maxHeight);
                doc.addImage(imgData2, 'PNG', marginLeft + imgWidth1 + 5, chartY, imgWidth2, maxHeight);

            // Tabla de datos
            const tableData = [
                ['Metric', 'Previous', 'Prediction', 'Percentage Difference'],
                ['Age', panssResults.pre_Age, "", ""],
                ['Gender', panssResults.pre_Gender, "", ""],
                ['Education', panssResults.pre_Education, "", ""],
                ['Marital', panssResults.pre_Marital, "", ""],
                ['Living', panssResults.pre_Living, "", ""],
                ['Employment', panssResults.pre_Employment, "", ""],
                ['Alcohol', panssResults.pre_Alcohol, "", ""],
                ['Caffeine', panssResults.pre_Caffeine, "", ""],
                ['Illicite', panssResults.pre_Illicite, "", ""],
                ['Cannabis', panssResults.pre_Cannabis, "", ""],
                ['Tabacoo', panssResults.pre_Tabacoo, "", ""],
                ['Diagnosis', panssResults.pre_Diagnosis, "", ""],
                ['Panss Positive 1', panssResults.pre_panssp1, "", ""],
                ['Panss Positive 2', panssResults.pre_panssp2, "", ""],
                ['Panss Positive 3', panssResults.pre_panssp3, "", ""],
                ['Panss Positive 4', panssResults.pre_panssp4, "", ""],
                ['Panss Positive 5', panssResults.pre_panssp5, "", ""],
                ['Panss Positive 6', panssResults.pre_panssp6, "", ""],
                ['Panss Positive 7', panssResults.pre_panssp7, "", ""],
                ['Panss Global 9', panssResults.pre_panssg9, "", ""],
                ['Panss Positive', panssResults.pre_panss_P, "", ""],
                ['Panss Negative', panssResults.pre_panss_N, "", ""],
                ['Panss General', panssResults.pre_panss_G, "", ""],
                ['Panss Total', panssResults.pre_panss_T, "", ""],
                ['TMT A', panssResults.pre_TMT_A_pd, "", ""],
                ['TMT B', panssResults.pre_TMT_B_pd, "", ""],
                ['GAF', panssResults.pre_gaf, "", ""],
                ['Quality of Life (QoL)', panssResults.pre_gen_qol, "", ""],
                ['JTC', panssResults.pre_jtc, "", ""],
                ['Depression', panssResults.pre_Depression, "", ""],
                ['Panss Positive', panssResults.pre_panss_P, panssResults.prediction_P, ` ${panssResults.diference_perc_P}`],
                ['Delusion according to PANSS', panssResults.pre_del_artifical, panssResults.prediction_del_artificial, ` ${panssResults.diference_DEL_ARTIFICIAL}`],
                ['PSYRAT Hal', panssResults.pre_psy_haltotal, panssResults.prediction_psy_hal, ` ${panssResults.diference_PSY_HAL}`],
                ['PSYRAT Del', panssResults.pre_psy_deltotal, panssResults.prediction_psy_del, ` ${panssResults.diference_PSY_DEL}`],
                ['Rosen', panssResults.pre_Rosen_total, panssResults.prediction_rosentotal, ` ${panssResults.diference_ROSENTOTAL}`],
                ['BCIS Total', panssResults.pre_BCISTOTAL, panssResults.prediction_bcis_total, ` ${panssResults.diference_BCISTOTAL}`],
                ['BCIS Reflex', panssResults.pre_BCIS_reflex, panssResults.prediction_bcisreflex, ` ${panssResults.diference_BCISREFLEX}`],
                ['BCIS Certez', panssResults.pre_BCIS_certez, panssResults.prediction_bciscertez, ` ${panssResults.diference_BCISCERTEZ}`]
            ];
    
            const tableY = chartY + maxHeight + 10;
            doc.autoTable({
                head: [tableData[0]],
                body: tableData.slice(1),
                startY: tableY
            });
        }

            // Gráficos adicionales (waterfall)
            for (const modelData of waterfallDataList) {
                const chartElement = chartRefs.current[modelData.id];
                if (!chartElement) continue;
            
                const previousDisplay = chartElement.style.display;
                const previousWidth = chartElement.style.width;
                const previousHeight = chartElement.style.height;
            
                chartElement.style.display = "flex";
                chartElement.style.width = "1000px";
                chartElement.style.height = "1400px";
            
                await new Promise(resolve => setTimeout(resolve, 500));
                await document.fonts.ready;
            
                const canvas = await html2canvas(chartElement, {
                    scale: 3,
                    useCORS: true,
                    backgroundColor: "#fff"
                });
            
                const imgData = canvas.toDataURL("image/png");
            
                const pageWidth = doc.internal.pageSize.getWidth();
                const pageHeight = doc.internal.pageSize.getHeight();
            
                const margin = 20;
                const imgWidth = pageWidth - margin * 2;
            
                // 🔹 Mantener proporción y evitar recorte en altura
                let imgHeight = (canvas.height * imgWidth) / canvas.width;
            
                // 🔸 Limitar altura si es mayor que la página
                if (imgHeight > pageHeight - 40) {
                    imgHeight = pageHeight - 40; // deja 20 de margen arriba y abajo
                }
            
                doc.addPage();
                doc.setFontSize(16);
                doc.text(modelData.title, 10, 20);
                doc.addImage(imgData, 'PNG', margin, 30, imgWidth, imgHeight);
            
                chartElement.style.display = previousDisplay;
                chartElement.style.width = previousWidth;
                chartElement.style.height = previousHeight;
            }
            

            doc.save("data_and_charts.pdf");

        } catch (err) {
            console.error("❌ Error:", err);
        } finally {
            setLoading(false);
            document.body.style.overflow = 'auto';
        }
    };

    const handleDownloadDictionary = async () => {
        const doc = new jsPDF();
        doc.setFontSize(12);
        const marginLeft = 10;
        const marginTop = 10;
        const pageWidth = doc.internal.pageSize.getWidth() - 2 * marginLeft;
    
        // Diccionario de definiciones
        const variableDefinitions = {
            Age: t("dictionary.Age"),
            Gender: t("dictionary.Gender"),
            Education: t("dictionary.Education"),
            Marital: t("dictionary.Marital"),
            Living: t("dictionary.Living"),
            Employment: t("dictionary.Employment"),
            Alcohol: t("dictionary.Alcohol"),
            Caffeine: t("dictionary.Caffeine"),
            Illicite: t("dictionary.Illicite"),
            Cannabis: t("dictionary.Cannabis"),
            Tabacoo: t("dictionary.Tabacoo"),
            Diagnosis: t("dictionary.Diagnosis"),
            Length_Illness: t("dictionary.Length_Illness"),
            pre_panss_P: t("dictionary.pre_panss_P"),
            pre_panss_N: t("dictionary.pre_panss_N"),
            pre_panss_G: t("dictionary.pre_panss_G"),
            pre_panss_T: t("dictionary.pre_panss_T"),
            pre_panssp1: t("dictionary.pre_panssp1"),
            pre_panssp2: t("dictionary.pre_panssp2"),
            pre_panssp3: t("dictionary.pre_panssp3"),
            pre_panssp4: t("dictionary.pre_panssp4"),
            pre_panssp5: t("dictionary.pre_panssp5"),
            pre_panssp6: t("dictionary.pre_panssp6"),
            pre_panssp7: t("dictionary.pre_panssp7"),
            pre_panssg9: t("dictionary.pre_panssg9"),
            pre_BCIS_reflex: t("dictionary.pre_BCIS_reflex"),
            pre_BCIS_certez: t("dictionary.pre_BCIS_certez"),
            pre_TMT_A_pd: t("dictionary.pre_TMT_A_pd"),
            pre_TMT_B_pd: t("dictionary.pre_TMT_B_pd"),
            pre_gaf: t("dictionary.pre_gaf"),
            pre_psy_haltotal: t("dictionary.pre_psy_haltotal"),
            pre_psy_deltotal: t("dictionary.pre_psy_deltotal"),
            pre_gen_qol: t("dictionary.pre_gen_qol"),
            pre_jtc: t("dictionary.pre_jtc"),
            Depression: t("dictionary.Depression"),
            Rosen_total: t("dictionary.Rosen_total"),
        };
    
        const glossaryRows = Object.entries(variableDefinitions).map(([variable, definition]) => [variable, definition]);
    
        doc.setFontSize(14);
        doc.text("Glossary of Variables", marginLeft, marginTop);
        doc.autoTable({
            head: [["Variable", "Definition"]],
            body: glossaryRows,
            startY: marginTop + 10,
            styles: { fontSize: 10, cellPadding: 3 },
            headStyles: { fillColor: [0, 102, 204] }
        });
    
        doc.save("dictionary.pdf");
    };

    // 🔹 **Datos para el gráfico de barras**
    /*const labels = panssResults.pred_feature_names || [];
    const values = panssResults.prediction_P_explain_vals || [];

    const chartData = {
        labels: labels,
        datasets: [
            {
                label: "Explanation Values",
                data: values,
                backgroundColor: values.map(val => val >= 0 ? "#387d38" : "#c65353"), // Verde positivo, rojo negativo
                borderWidth: 1,
            },
        ],
    };

    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: { display: false },
            title: { display: true, text: "Prediction P Explain Values" },
        },
        scales: {
            y: {
                beginAtZero: true,
                ticks: {
                    callback: function(value) {
                        return value.toFixed(2);  // Redondeo a 2 decimales
                    },
                },
            },
            x: {
                ticks: { autoSkip: false, maxRotation: 45, minRotation: 45 },
            },
        },
    };*/

    // Graphs scales
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: true,
                labels: {
                    generateLabels: function(chart) {
                        return [
                            {
                                text: improvementText, // Texto dinámico para "Mejora"
                                fillStyle: '#387d38', // Color para la mejora (verde)
                            },
                            {
                                text: deteriorationText, // Texto dinámico para "Empeoramiento"
                                fillStyle: '#c65353', // Color para el empeoramiento (rojo)
                            }
                        ];
                    },
                    font: {
                        size: 16, // Tamaño de fuente de las etiquetas de datos
                    },
                },
                position: 'top',
            },
            title: {
                display: true,
                text: 'Percentage Difference',
                font: {
                    size: 20, // Tamaño de fuente de las etiquetas de datos
                }
            },
            datalabels: {
                display: true,
                align: 'top',
                anchor: 'end',
                formatter: (value) => `${value}%`,
                color: '#000',
            },
            tooltip: {
                enabled: false // Desactiva el tooltip
            },
        },
        scales: {
            y: {
                beginAtZero: true,
                suggestedMin: Math.min(
                    panssResults.diference_perc_P, 
                    panssResults.diference_PSY_DEL, 
                    panssResults.diference_ROSENTOTAL, 
                    panssResults.diference_BCISREFLEX, 
                    panssResults.diference_BCISCERTEZ
                )-10,
                suggestedMax: Math.max(
                    panssResults.diference_perc_P, 
                    panssResults.diference_PSY_DEL, 
                    panssResults.diference_ROSENTOTAL, 
                    panssResults.diference_BCISREFLEX, 
                    panssResults.diference_BCISCERTEZ,
                    )+10,
                ticks: {
                    callback: function(value) {
                        return value + '%'; // Asegura que los ticks del eje Y muestren los porcentajes
                    },
                    font: {
                        size: 16, // Tamaño de fuente de las etiquetas de datos
                    }
                }
            },
            x:{
                ticks: {
                    font: {
                        size: 16, // Tamaño de fuente para las etiquetas del eje Y
                    }
                }
            }
        },
    };
    
    const optionsCompletation = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false, // Ocultar la leyenda si no es necesaria
                // font: {
                //     size: 1600, // Tamaño de fuente para las etiquetas de la leyenda
                // }
            },
            title: {
                display: true,
                text: 'Probability MCT completion',
                font: {
                    size: 20, // Tamaño de fuente del título del gráfico
                }
            },
            datalabels: {
                display: true,
                align: 'end', // Alinea las etiquetas al final de las barras
                anchor: 'end', // Ancla las etiquetas al final de las barras
                formatter: (value) => `${value}%`, // Formato de la etiqueta
                color: '#000', // Color de la etiqueta
                backgroundColor: 'rgba(255, 255, 255, 0.8)', // Fondo blanco con transparencia para mejorar visibilidad
                borderRadius: 3, // Bordes redondeados para la etiqueta
                padding: 4, // Espaciado dentro de la etiqueta
                font: {
                    size: 16, // Tamaño de fuente de las etiquetas de datos
                }
            },
            tooltip: {
                enabled: false // Desactiva el tooltip
            }
        },
        scales: {
            y: {
                beginAtZero: true,
                suggestedMin: 0,
                suggestedMax: Math.max(
                    panssResults.completion_prob,
                    )+10, // Asegura que el eje Y sea suficientemente alto para mostrar la etiqueta
                ticks: {
                    callback: function(value) {
                        return value + '%'; // Asegura que los ticks del eje Y muestren los porcentajes
                    },
                    font: {
                        size: 16, // Tamaño de fuente para las etiquetas del eje Y
                    }
                }
            },
            x: {
                ticks: {
                    autoSkip: false, // Asegura que todas las etiquetas de eje X se muestren
                    font: {
                        size: 16, // Tamaño de fuente para las etiquetas del eje Y
                    }
                },
            },
        },
    };
    // Graph data
    const dataPercentage = {
        labels: ['Panss Pos.', 'PSYRATS Del.', 'Rosen', 'BCIS Reflex', 'BCIS Certez'],
        datasets: [
            {
                label: 'Percentage difference',
                data: [panssResults.diference_perc_P, panssResults.diference_PSY_DEL, panssResults.diference_ROSENTOTAL, panssResults.diference_BCISREFLEX, panssResults.diference_BCISCERTEZ],
                backgroundColor: [
                    panssResults.diference_perc_P > 0 ? '#387d38' : '#c65353',
                    panssResults.diference_PSY_DEL > 0 ? '#387d38' : '#c65353',
                    panssResults.diference_ROSENTOTAL > 0 ? '#387d38' : '#c65353',
                    panssResults.diference_BCISREFLEX > 0 ? '#387d38' : '#c65353',
                    panssResults.diference_BCISCERTEZ > 0 ? '#387d38' : '#c65353'
                ],
                borderColor: ['#a0c1c6'],
                borderWidth: 1,
            },
        ],
    };

    const dataCompletation = {
        labels: ['Completion'],
        datasets: [
            {
                label: 'Completion Percentage',
                data: [panssResults.completion_prob],
                backgroundColor: [panssResults.completion_prob],
                borderColor: ['#a0c1c6'],
                borderWidth: 1,
            }
        ]
    };

    // 🔹 **Datos para el WaterfallChart**
    /* FUNCIONA
    const predictionData = panssResults.prediction_P_explain_vals.map((valuesArray, index) => 
        valuesArray.map((value, subIndex) => ({
            name: panssResults.pred_feature_names[subIndex], // añadir panssResult(por rellenar)+" = "+ para que se vea como en la foto
            value: value
        }))
    ).flat(); // Aplanar el array para obtener una lista plana de objetos
    
    
    console.log("predictionData:", predictionData);
    console.log("vals: ",panssResults.prediction_P_explain_vals);
    console.log("feature names: ",panssResults.pred_feature_names);
    */
   //TEST FORM ERROR
    /*const flattenedValues = panssResults.prediction_P_explain_vals.flat(); // Aplanamos el array

    const predictionData = flattenedValues.map((value, index) => {
        let featureName = panssResults.pred_feature_names[index];
    
        // Solo añadimos "pre_" si el nombre de la variable no lo tiene ya
        if (!featureName.startsWith("pre_")) {
            featureName = `pre_${featureName}`;
        }
    
        // Obtenemos el valor previo de panssResults o asignamos "N/A" si no existe
        const preValue = panssResults[featureName] !== undefined ? panssResults[featureName] : "N/A";
    
        return {
            name: `${preValue} = ${featureName.replace("pre_", "")}`, // Muestra el valor antes del nombre
            value: value
        };
    });*/
    console.log("PanssResults:", panssResults);
    const pre_data = [
        panssResults.pre_Age,
        panssResults.pre_Gender,
        panssResults.pre_Education,
        panssResults.pre_Marital,
        panssResults.pre_Living,
        panssResults.pre_Employment,
        panssResults.pre_Alcohol,
        panssResults.pre_Caffeine,
        panssResults.pre_Illicite,
        panssResults.pre_Cannabis,
        panssResults.pre_Tabacoo,
        panssResults.pre_Diagnosis,
        panssResults.pre_Length_Illness,
        panssResults.pre_panss_P,
        panssResults.pre_panss_N,
        panssResults.pre_panss_G,
        panssResults.pre_panss_T,
        panssResults.pre_panssp1,
        panssResults.pre_panssp2,
        panssResults.pre_panssp3,
        panssResults.pre_panssp4,
        panssResults.pre_panssp5,
        panssResults.pre_panssp6,
        panssResults.pre_panssp7,
        panssResults.pre_panssg9,
        panssResults.pre_BCIS_reflex,
        panssResults.pre_BCIS_certez,
        panssResults.pre_Rosen_total,
        panssResults.pre_TMT_A_pd,
        panssResults.pre_TMT_B_pd,
        panssResults.pre_gaf,
        panssResults.pre_psy_haltotal,
        panssResults.pre_psy_deltotal,
        panssResults.pre_gen_qol,
        panssResults.pre_jtc,
        panssResults.pre_Depression,
      ];
      
    const waterfallDataList = [
        { 
            id: "panssp",
            title: t("graphs.panssp"), // Título de la gráfica
            base: [panssResults.prediction_P_explain_base], // Valor base de esta gráfica
            prediction: panssResults.real_prediction_P[0], // Predicción final
            data: panssResults.prediction_P_explain_vals/*.map((value, index) => ({ 
                name: panssResults.pred_feature_names[index], 
                value: value 
            }))*/
        },
        { 
            id: "del_artificial",
            title: t("graphs.del_artificial"), 
            base: panssResults.prediction_del_artificial_explain_base, 
            prediction: panssResults.real_prediction_del_artificial[0], 
            data: panssResults.prediction_del_artificial_explain_vals/*.map((value, index) => ({ 
                name: panssResults.pred_feature_names[index], 
                value : value
            }))*/
        },
        { 
            id: "psy_haltotal",
            title: t("graphs.psy_haltotal"), 
            base: panssResults.prediction_psy_hal_explain_base, 
            prediction: panssResults.real_prediction_psy_hal[0], 
            data: panssResults.prediction_psy_hal_explain_vals/*.map((value, index) => ({ 
                name: panssResults.pred_feature_names[index], 
                value : value
            })) */
        },
        { 
            id: "psy_deltotal",
            title: t("graphs.psy_deltotal"), 
            base: panssResults.prediction_psy_del_explain_base, 
            prediction: panssResults.real_prediction_psy_del[0], 
            data: panssResults.prediction_psy_del_explain_vals/*.map((value, index) => ({ 
                name: panssResults.pred_feature_names[index], 
                value : value
            })) */
        },
        { 
            id: "Rosen_total",
            title: t("graphs.Rosen_total"), 
            base: panssResults.prediction_rosentotal_explain_base, 
            prediction: panssResults.real_prediction_rosentotal[0], 
            data: panssResults.prediction_rosentotal_explain_vals/*.map((value, index) => ({ 
                name: panssResults.pred_feature_names[index], 
                value : value
            })) */
        },
        { 
            id: "BCIS_reflex",
            title: t("graphs.BCIS_reflex"), 
            base: panssResults.prediction_bcisreflex_explain_base, 
            prediction: panssResults.real_prediction_bcisreflex[0], 
            data: panssResults.prediction_bcisreflex_explain_vals/*.map((value, index) => ({ 
                name: panssResults.pred_feature_names[index], 
                value : value
            })) */
        },
        { 
            id: "BCIS_certez",
            title: t("graphs.BCIS_certez"), 
            base: panssResults.prediction_bciscertez_explain_base, 
            prediction: panssResults.real_prediction_bciscertez[0], 
            data: panssResults.prediction_bciscertez_explain_vals/*.map((value, index) => ({ 
                name: panssResults.pred_feature_names[index], 
                value : value
            })) */
        },
        {
            id: "completation",
            title: t("graphs.completation"),  
            base: panssResults.completion_explain_base,
            prediction: panssResults.completation[0], 
            data: panssResults.completion_explain_vals/*.map((value, index) => ({ 
                name: panssResults.pred_feature_names[index], 
                value : value
            })) */
        },
    ];
    
    // Imprimir para verificar estructura
    console.log("Debugging waterfallDataList:", waterfallDataList);
    console.log("🔍 Sumas de cada *_explain_vals:");

    const variables = [
        "prediction_P_explain_vals",
        "prediction_del_artificial_explain_vals",
        "prediction_psy_hal_explain_vals",
        "prediction_psy_del_explain_vals",
        "prediction_rosentotal_explain_vals",
        "prediction_bcisreflex_explain_vals",
        "prediction_bciscertez_explain_vals",
        "completion_explain_vals"
      ];
      
      variables.forEach((key) => {
        const valsWrapper = panssResults[key];
        if (Array.isArray(valsWrapper) && Array.isArray(valsWrapper[0])) {
          const vals = valsWrapper[0];
          const sum = vals.reduce((acc, val) => acc + val, 0);
          console.log(`${key}: ${sum.toFixed(4)}`);
        } else {
          console.warn(`⚠️ ${key} no es un array anidado como se esperaba`);
        }
      });
      


    

    return (
        <>
            {loading && (
                <div className="overlay">
                <img
                  src="https://i.gifer.com/ZZ5H.gif"
                  alt={t("buttons.loading")}
                  style={{ width: "80px", height: "80px" }}
                />
                </div>
            )}
            <Container ref={contentRef}>
                <Row>
                    <Col>
                        <h3 className="mt-5 mb-5">{t("results.titles.questionnaires")}</h3>
                        <ListGroup>
                            <ListGroup.Item 
                                style={{
                                    backgroundColor: '#F8F9FA',
                                    cursor: 'pointer',        
                                    color: '#0d6efd',         
                                    textDecoration: 'underline' }}
                                    as="a"
                                action
                                /*onClick={() => {
                                    setVisibleChart("panssp");
                                    setTimeout(() => {
                                    window.location.hash = "chart-pansp";
                                    }, 50);
                                }}*/
                                onClick={() => {
                                    setVisibleChart("panssp");
                                    setTimeout(() => {
                                    chartRefs.current["panssp"]?.scrollIntoView({ behavior: "smooth", block: "start" });
                                    }, 100);
                                }}
                            >
                                {t("results.pansp")}
                            </ListGroup.Item>
                            <ListGroup.Item
                                style={{
                                    cursor: 'pointer',        
                                    color: '#0d6efd',         
                                    textDecoration: 'underline' }}
                                action
                                //onClick={() => setVisibleChart("del_artificial")}
                                onClick={() => {
                                    setVisibleChart("del_artificial");
                                    setTimeout(() => {
                                    chartRefs.current["del_artificial"]?.scrollIntoView({ behavior: "smooth", block: "start" });
                                    }, 100);
                                }}
                            >
                                {t("results.del_artifical")}
                                <InfoIcon infoText="Delusions according to PANSS"/>
                            </ListGroup.Item>
                            <ListGroup.Item 
                                as="a"
                                style={{
                                    backgroundColor: '#F8F9FA',
                                    cursor: 'pointer',        
                                    color: '#0d6efd',         
                                    textDecoration: 'underline' }}
                                action
                                /*onClick={() => {
                                    setVisibleChart("psy_haltotal");
                                    setTimeout(() => {
                                      window.location.hash = "chart-psy_haltotal";
                                    }, 50);
                                  }}*/
                                onClick={() => {
                                    setVisibleChart("psy_haltotal");
                                    setTimeout(() => {
                                    chartRefs.current["psy_haltotal"]?.scrollIntoView({ behavior: "smooth", block: "start" });
                                    }, 100);
                                }}
                                >
                                {t("results.psy_haltotal")}
                            </ListGroup.Item>
                            <ListGroup.Item
                            style={{
                                cursor: 'pointer',        
                                color: '#0d6efd',         
                                textDecoration: 'underline' }}
                                as="a"
                                action
                                /*onClick={() => {
                                    setVisibleChart("psy_deltotal");
                                    setTimeout(() => {
                                      window.location.hash = "chart-psy_deltotal";
                                    }, 50);
                                  }}*/
                                  onClick={() => {
                                      setVisibleChart("psy_deltotal");
                                      setTimeout(() => {
                                      chartRefs.current["psy_deltotal"]?.scrollIntoView({ behavior: "smooth", block: "start" });
                                      }, 100);
                                  }}
                            >
                                {t("results.psy_deltotal")}
                            </ListGroup.Item>
                            <ListGroup.Item 
                                as="a"
                                style={{
                                    backgroundColor: '#F8F9FA',
                                    cursor: 'pointer',        
                                    color: '#0d6efd',         
                                    textDecoration: 'underline' }}
                                action
                                /*onClick={() => {
                                    setVisibleChart("Rosen_total");
                                    setTimeout(() => {
                                      window.location.hash = "chart-Rosen_total";
                                    }, 50);
                                  }}*/
                                  onClick={() => {
                                      setVisibleChart("Rosen_total");
                                      setTimeout(() => {
                                      chartRefs.current["Rosen_total"]?.scrollIntoView({ behavior: "smooth", block: "start" });
                                      }, 100);
                                  }}
                            >
                                {t("results.Rosen_total")}
                            </ListGroup.Item>
                            <ListGroup.Item>
                                {t("results.BCISTOTAL")}
                            </ListGroup.Item>
                            <ListGroup.Item 
                                as="a"
                                style={{
                                    backgroundColor: '#F8F9FA',
                                    cursor: 'pointer',        
                                    color: '#0d6efd',         
                                    textDecoration: 'underline'}}
                                action
                                /*onClick={() => {
                                    setVisibleChart("BCIS_reflex");
                                    setTimeout(() => {
                                      window.location.hash = "chart-BCIS_reflex";
                                    }, 50);
                                  }}*/
                                  onClick={() => {
                                      setVisibleChart("BCIS_reflex");
                                      setTimeout(() => {
                                      chartRefs.current["BCIS_reflex"]?.scrollIntoView({ behavior: "smooth", block: "start" });
                                      }, 100);
                                  }}
                            >
                                {t("results.BCIS_reflex")}
                            </ListGroup.Item>
                            <ListGroup.Item
                            style={{
                                cursor: 'pointer',        
                                color: '#0d6efd',         
                                textDecoration: 'underline' }}
                                as="a"
                                action
                                /*onClick={() => {
                                    setVisibleChart("BCIS_certez");
                                    setTimeout(() => {
                                      window.location.hash = "chart-BCIS_certez";
                                    }, 50);
                                  }}*/
                                  onClick={() => {
                                      setVisibleChart("BCIS_certez");
                                      setTimeout(() => {
                                      chartRefs.current["BCIS_certez"]?.scrollIntoView({ behavior: "smooth", block: "start" });
                                      }, 100);
                                  }}
                            >
                                {t("results.BCIS_certez")}
                            </ListGroup.Item>
                            <ListGroup.Item 
                                as="a"
                                style={{
                                    backgroundColor: '#F8F9FA',
                                    cursor: 'pointer',        
                                    color: '#0d6efd',         
                                    textDecoration: 'underline' }}
                                action
                                /*onClick={() => {
                                    setVisibleChart("completation");
                                    setTimeout(() => {
                                      window.location.hash = "chart-completation";
                                    }, 50);
                                  }}*/
                                  onClick={() => {
                                      setVisibleChart("completation");
                                      setTimeout(() => {
                                      chartRefs.current["completation"]?.scrollIntoView({ behavior: "smooth", block: "start" });
                                      }, 100);
                                  }}
                            >
                                {t("results.completation")}
                            </ListGroup.Item>
                        </ListGroup>
                    </Col>

                    <Col>
                        <h3 className="mt-5 mb-5">{t("results.titles.previous")}</h3>
                        <ListGroup>
                            <ListGroup.Item style={{backgroundColor: '#F8F9FA'}}>
                                {panssResults.pre_panss_P}
                            </ListGroup.Item>
                            <ListGroup.Item>
                                {panssResults.pre_del_artifical}
                            </ListGroup.Item>
                            <ListGroup.Item style={{backgroundColor: '#F8F9FA'}}>
                                {panssResults.pre_psy_haltotal}
                            </ListGroup.Item>
                            <ListGroup.Item>
                                {panssResults.pre_psy_deltotal}
                            </ListGroup.Item>
                            <ListGroup.Item style={{backgroundColor: '#F8F9FA'}}>
                                {panssResults.pre_Rosen_total}
                            </ListGroup.Item>
                            <ListGroup.Item>
                                {panssResults.pre_BCISTOTAL}
                            </ListGroup.Item>
                            <ListGroup.Item style={{backgroundColor: '#F8F9FA'}}>
                                {panssResults.pre_BCIS_reflex}
                            </ListGroup.Item>
                            <ListGroup.Item>
                                {panssResults.pre_BCIS_certez}
                            </ListGroup.Item>
                        </ListGroup>
                    </Col>

                    <Col>
                        <h3 className="mt-5 mb-5">{t("results.titles.predictions")}</h3>
                        <ListGroup>
                            <ListGroup.Item style={{backgroundColor: '#F8F9FA'}}>
                                {panssResults.prediction_P}
                            </ListGroup.Item>
                            <ListGroup.Item>
                                {panssResults.prediction_del_artificial}
                            </ListGroup.Item>
                            <ListGroup.Item style={{backgroundColor: '#F8F9FA'}}>
                                {panssResults.prediction_psy_hal}
                            </ListGroup.Item>
                            <ListGroup.Item>
                                {panssResults.prediction_psy_del}
                            </ListGroup.Item>
                            <ListGroup.Item style={{backgroundColor: '#F8F9FA'}}>
                                {panssResults.prediction_rosentotal}
                            </ListGroup.Item>
                            <ListGroup.Item>
                                {panssResults.prediction_bcis_total}
                            </ListGroup.Item>
                            <ListGroup.Item style={{backgroundColor: '#F8F9FA'}}>
                                {panssResults.prediction_bcisreflex}
                            </ListGroup.Item>
                            <ListGroup.Item>
                                {panssResults.prediction_bciscertez}
                            </ListGroup.Item>
                            <ListGroup.Item style={{backgroundColor: '#F8F9FA'}}>
                                {panssResults.completation}
                            </ListGroup.Item>
                        </ListGroup>
                    </Col>

                    <Col>
                        <h3 className="mt-5 mb-5">Percentage</h3>
                        <ListGroup>
                            <ListGroup.Item style={{backgroundColor: '#F8F9FA'}}>
                                {panssResults.diference_perc_P}%
                            </ListGroup.Item>
                            <ListGroup.Item>
                                {panssResults.diference_DEL_ARTIFICIAL}%
                            </ListGroup.Item>
                            <ListGroup.Item style={{backgroundColor: '#F8F9FA'}}>
                                {panssResults.diference_PSY_HAL}%
                            </ListGroup.Item>
                            <ListGroup.Item>
                                {panssResults.diference_PSY_DEL}%
                            </ListGroup.Item>
                            <ListGroup.Item style={{backgroundColor: '#F8F9FA'}}>
                                {panssResults.diference_ROSENTOTAL}%
                            </ListGroup.Item>
                            <ListGroup.Item>
                                {panssResults.diference_BCISTOTAL}%
                            </ListGroup.Item>
                            <ListGroup.Item style={{backgroundColor: '#F8F9FA'}}>
                                {panssResults.diference_BCISREFLEX}%
                            </ListGroup.Item>
                            <ListGroup.Item>
                                {panssResults.diference_BCISCERTEZ}%
                            </ListGroup.Item>
                        </ListGroup>
                    </Col>
                </Row>
                <Row className="mb-3 mt-3">
                    <Col className="mb-3">
                        <Button variant="primary" onClick={handleDownloadCSV} className="mb-2 mt-2">
                            Download CSV
                        </Button>
                    </Col>
                    <Col className="mb-3">
                        <Button variant="primary" onClick={handleDownloadPDF} className="mb-2 mt-2">
                            Download PDF
                        </Button>
                    </Col>
                    <Col className="mb-3">
                        <Button variant="primary" onClick={handleDownloadDictionary} className="mb-2 mt-2">
                            Download Dictionary
                        </Button>
                    </Col>
                    <Col className="mb-3">
                        <Button variant="link" onClick={handleShow} className="mb-2 mt-2">
                            {t("results.button")}
                        </Button>
                    </Col>
                </Row>
                <Row className="mb-3 mt-3">
                    <Col className="mb-3">
                        <p>{t("results.warningAI")} <a href="https://www.europarl.europa.eu/topics/en/article/20230601STO93804/eu-ai-act-first-regulation-on-artificial-intelligence">EU AI Act</a>.</p>
                    </Col>
                </Row>
            <Row className="mb-3 mt-3 chart-row">
                <h3>{t("results.titles.percentage")}</h3>
                <div className="mb-3 mt-3 chart-container">
                    <div className="canvas-wrapper">
                        <BarChart data={dataPercentage} options={options} />
                    </div>
                </div>
                <div className="mb-3 mt-3 chart-container-right">
                    <div className="canvas-wrapper">
                        <BarChart data={dataCompletation} options={optionsCompletation} />
                    </div>
                </div>
            </Row>
                <Row className="mb-3">
                    <Col>
                        <h3>Top 3 Lowest Difference Indicators</h3>
                        <ListGroup>
                            {lowestIndicators.map((indicator, index) => (
                                <ListGroup.Item key={index}>
                                    <a href={keyMapping[indicator]?.url} target="_blank" rel="noopener noreferrer">
                                        {keyMapping[indicator]?.name}
                                    </a>
                                </ListGroup.Item>
                            ))}
                        </ListGroup>
                    </Col>
                </Row>
                {waterfallDataList.map((modelData, index) => (
                    //<Row key={index} className="mb-5" style={{ display: "none" }}>
                    <Row 
                        key={index} 
                        id={`chart-${modelData.id}`}
                        ref={(el) => (chartRefs.current[modelData.id as ChartId] = el)}
                        className="mb-5"
                        style={{ display: visibleChart === modelData.id ? "flex" : "none" }}
                        >
                        <Col xs={12}>
                            <h3>{modelData.title}</h3>
                            <PositiveAndNegativeBarChart
                                data={modelData.data}
                                title={`${modelData.title}`} 
                                predictionBase= {modelData.base}
                                predictionResult= {modelData.prediction}
                                featured_names={panssResults.pred_feature_names}
                                pre_data={pre_data}
                            />
                        </Col>
                    </Row>
                ))}

                {/*{waterfallDataList.map((chartData, index) => (
                    <Row className="mb-3" key={index}>
                        <Col xs={12}>
                            <h3>{chartData.title}</h3>
                            <PositiveAndNegativeBarChart  
                                data={chartData.data} 
                                title={`${chartData.title} Contribution`} 
                                predictionBase={chartData.base} 
                                predictionResult={chartData.prediction} 
                            />
                        </Col>
                    </Row>
                ))}*/}
            </Container>

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {t("results.titles.pipeline-versions")}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ListGroup>
                        <ListGroup.Item>
                            {t("results.pansp")}
                            {panssResults.model_P_version}
                        </ListGroup.Item>
                        <ListGroup.Item>
                            {t("results.del_artifical")}
                            {panssResults.model_DEL_ARTIFICIAL}
                        </ListGroup.Item>
                        <ListGroup.Item>
                            {t("results.psy_haltotal")}
                            {panssResults.model_PSY_HAL_version}
                        </ListGroup.Item>
                        <ListGroup.Item>
                            {t("results.psy_deltotal")}
                            {panssResults.model_PSY_DEL_version}
                        </ListGroup.Item>
                        <ListGroup.Item>
                            {t("results.Rosen_total")}
                            {panssResults.model_ROSENTOTAL_version}
                        </ListGroup.Item>
                        <ListGroup.Item>
                            {t("results.BCIS_reflex")}
                            {panssResults.model_BCISREFLEX_version}
                        </ListGroup.Item>
                        <ListGroup.Item>
                            {t("results.BCIS_certez")}
                            {panssResults.model_BCISCERTEZ_version}
                        </ListGroup.Item>
                        <ListGroup.Item>
                            {t("results.completation")}
                            {panssResults.model_MTC_COMPLETION_version}
                        </ListGroup.Item>
                    </ListGroup>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        {t("buttons.close")}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default ResultPage;